var map = {
	"./Icon-block-checkup-32px-blauw.svg": "0ec8",
	"./Icon-block-checkup-32px-groen.svg": "30ea",
	"./Icon-block-checkup-32px-groengrijs.svg": "8d14",
	"./Icon-block-checkup-32px-koraalrood.svg": "d2a0",
	"./Icon-block-checkup-32px-magenta.svg": "7816",
	"./Icon-block-checkup-32px-okergeel.svg": "334b",
	"./Icon-block-checkup-32px-paars.svg": "64b0",
	"./Icon-block-checkup-32px-turkoois.svg": "636c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4fc6";